
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0
}
.pointer-events-none {
    pointer-events: none
}
.pointer-events-auto {
    pointer-events: auto
}
.visible {
    visibility: visible
}
.invisible {
    visibility: hidden
}
.static {
    position: static
}
.fixed {
    position: fixed
}
.absolute {
    position: absolute
}
.relative {
    position: relative
}
.sticky {
    position: sticky
}
.inset-0 {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px
}
.bottom-0 {
    bottom: 0px
}
.left-0 {
    left: 0px
}
.bottom-4 {
    bottom: 1rem
}
.right-4 {
    right: 1rem
}
.top-0 {
    top: 0px
}
.right-0 {
    right: 0px
}
.top-2 {
    top: 0.5rem
}
.right-2 {
    right: 0.5rem
}
.bottom-11 {
    bottom: 2.75rem
}
.bottom-1 {
    bottom: 0.25rem
}
.-bottom-12 {
    bottom: -3rem
}
.right-14 {
    right: 3.5rem
}
.top-8 {
    top: 2rem
}
.top-5 {
    top: 1.25rem
}
.top-4 {
    top: 1rem
}
.left-2 {
    left: 0.5rem
}
.top-3 {
    top: 0.75rem
}
.right-3 {
    right: 0.75rem
}
.right-5 {
    right: 1.25rem
}
.right-7 {
    right: 1.75rem
}
.right-16 {
    right: 4rem
}
.top-2\.5 {
    top: 0.625rem
}
.right-2\.5 {
    right: 0.625rem
}
.top-\[5rem\] {
    top: 5rem
}
.-top-\[18px\] {
    top: -18px
}
.left-1\/2 {
    left: 50%
}
.top-1\/2 {
    top: 50%
}
.top-\[60\%\] {
    top: 60%
}
.top-\[45\%\] {
    top: 45%
}
.bottom-2\/4 {
    bottom: 50%
}
.bottom-\[inherit\] {
    bottom: inherit
}
.right-\[inherit\] {
    right: inherit
}
.top-\[5px\] {
    top: 5px
}
.left-\[5px\] {
    left: 5px
}
.bottom-\[-2\.5rem\] {
    bottom: -2.5rem
}
.left-\[-0\.5rem\] {
    left: -0.5rem
}
.right-\[-1rem\] {
    right: -1rem
}
.top-\[2\.5rem\] {
    top: 2.5rem
}
.bottom-\[1\.5rem\] {
    bottom: 1.5rem
}
.left-\[50\%\] {
    left: 50%
}
.top-\[calc\(100vw\/1\.56\)\] {
    top: calc(100vw / 1.56)
}
.left-\[-2px\] {
    left: -2px
}
.right-\[-2px\] {
    right: -2px
}
.top-2\/4 {
    top: 50%
}
.left-\[-4rem\] {
    left: -4rem
}
.z-40 {
    z-index: 40
}
.z-50 {
    z-index: 50
}
.z-10 {
    z-index: 10
}
.z-0 {
    z-index: 0
}
.z-20 {
    z-index: 20
}
.z-30 {
    z-index: 30
}
.z-\[1000\] {
    z-index: 1000
}
.z-\[1\] {
    z-index: 1
}
.z-\[30\] {
    z-index: 30
}
.z-\[29\] {
    z-index: 29
}
.z-\[60\] {
    z-index: 60
}
.order-1 {
    order: 1
}
.order-first {
    order: -9999
}
.order-2 {
    order: 2
}
.col-span-12 {
    grid-column: span 12 / span 12
}
.col-span-4 {
    grid-column: span 4 / span 4
}
.col-span-1 {
    grid-column: span 1 / span 1
}
.col-span-2 {
    grid-column: span 2 / span 2
}
.col-start-3 {
    grid-column-start: 3
}
.col-start-1 {
    grid-column-start: 1
}
.col-start-2 {
    grid-column-start: 2
}
.col-end-2 {
    grid-column-end: 2
}
.row-start-1 {
    grid-row-start: 1
}
.row-start-2 {
    grid-row-start: 2
}
.float-right {
    float: right
}
.float-left {
    float: left
}
.float-none {
    float: none
}
.m-0 {
    margin: 0px
}
.m-12 {
    margin: 3rem
}
.m-auto {
    margin: auto
}
.m-8 {
    margin: 2rem
}
.m-2 {
    margin: 0.5rem
}
.m-4 {
    margin: 1rem
}
.my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem
}
.mx-auto {
    margin-left: auto;
    margin-right: auto
}
.my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem
}
.my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem
}
.my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem
}
.my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem
}
.my-9 {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem
}
.my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem
}
.my-0 {
    margin-top: 0px;
    margin-bottom: 0px
}
.mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem
}
.mx-0 {
    margin-left: 0px;
    margin-right: 0px
}
.my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem
}
.mx-4 {
    margin-left: 1rem;
    margin-right: 1rem
}
.mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem
}
.my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem
}
.mx-\[15\%\] {
    margin-left: 15%;
    margin-right: 15%
}
.mb-6 {
    margin-bottom: 1.5rem
}
.mr-2 {
    margin-right: 0.5rem
}
.ml-2 {
    margin-left: 0.5rem
}
.mb-4 {
    margin-bottom: 1rem
}
.mt-8 {
    margin-top: 2rem
}
.mt-6 {
    margin-top: 1.5rem
}
.mb-10 {
    margin-bottom: 2.5rem
}
.mt-2 {
    margin-top: 0.5rem
}
.mt-0 {
    margin-top: 0px
}
.mr-3 {
    margin-right: 0.75rem
}
.mb-2 {
    margin-bottom: 0.5rem
}
.ml-1 {
    margin-left: 0.25rem
}
.mb-5 {
    margin-bottom: 1.25rem
}
.mb-0 {
    margin-bottom: 0px
}
.ml-0 {
    margin-left: 0px
}
.mt-4 {
    margin-top: 1rem
}
.mb-8 {
    margin-bottom: 2rem
}
.mr-8 {
    margin-right: 2rem
}
.-mb-4 {
    margin-bottom: -1rem
}
.ml-4 {
    margin-left: 1rem
}
.mr-12 {
    margin-right: 3rem
}
.mb-3 {
    margin-bottom: 0.75rem
}
.ml-auto {
    margin-left: auto
}
.mb-7 {
    margin-bottom: 1.75rem
}
.mr-0 {
    margin-right: 0px
}
.mt-3 {
    margin-top: 0.75rem
}
.mr-1 {
    margin-right: 0.25rem
}
.ml-8 {
    margin-left: 2rem
}
.mb-1 {
    margin-bottom: 0.25rem
}
.mt-80 {
    margin-top: 20rem
}
.mt-28 {
    margin-top: 7rem
}
.mt-auto {
    margin-top: auto
}
.mt-1 {
    margin-top: 0.25rem
}
.ml-5 {
    margin-left: 1.25rem
}
.ml-3 {
    margin-left: 0.75rem
}
.mr-6 {
    margin-right: 1.5rem
}
.-ml-1 {
    margin-left: -0.25rem
}
.mr-4 {
    margin-right: 1rem
}
.ml-7 {
    margin-left: 1.75rem
}
.ml-14 {
    margin-left: 3.5rem
}
.mt-10 {
    margin-top: 2.5rem
}
.mb-\[1px\] {
    margin-bottom: 1px
}
.mt-\[1px\] {
    margin-top: 1px
}
.-mt-\[2\] {
    margin-top: -2
}
.mb-0\.5 {
    margin-bottom: 0.125rem
}
.ml-\[4\.5rem\] {
    margin-left: 4.5rem
}
.box-border {
    box-sizing: border-box
}
.block {
    display: block
}
.inline-block {
    display: inline-block
}
.inline {
    display: inline
}
.flex {
    display: flex
}
.inline-flex {
    display: inline-flex
}
.table {
    display: table
}
.grid {
    display: grid
}
.inline-grid {
    display: inline-grid
}
.contents {
    display: contents
}
.hidden {
    display: none
}
.aspect-square {
    aspect-ratio: 1 / 1
}
.aspect-\[1\.47\] {
    aspect-ratio: 1.47
}
.aspect-\[16\/9\] {
    aspect-ratio: 16 / 9
}
.h-full {
    height: 100%
}
.h-screen {
    height: 100vh
}
.h-full-screen-h {
    height: 100vh
}
.h-0 {
    height: 0px
}
.h-3 {
    height: 0.75rem
}
.h-16 {
    height: 4rem
}
.h-10 {
    height: 2.5rem
}
.h-auto {
    height: auto
}
.h-2 {
    height: 0.5rem
}
.h-5 {
    height: 1.25rem
}
.h-20 {
    height: 5rem
}
.h-9 {
    height: 2.25rem
}
.h-6 {
    height: 1.5rem
}
.h-8 {
    height: 2rem
}
.h-4 {
    height: 1rem
}
.h-fit {
    height: -moz-fit-content;
    height: fit-content
}
.h-\[40px\] {
    height: 40px
}
.h-\[490px\] {
    height: 490px
}
.h-\[50px\] {
    height: 50px
}
.h-\[35px\] {
    height: 35px
}
.h-\[88\%\] {
    height: 88%
}
.h-\[2px\] {
    height: 2px
}
.h-\[117px\] {
    height: 117px
}
.h-\[223px\] {
    height: 223px
}
.h-\[98\.5\%\] {
    height: 98.5%
}
.h-\[6px\] {
    height: 6px
}
.h-\[61px\] {
    height: 61px
}
.h-\[225px\] {
    height: 225px
}
.h-\[115px\] {
    height: 115px
}
.h-\[0\.75rem\] {
    height: 0.75rem
}
.h-\[255px\] {
    height: 255px
}
.h-\[270px\] {
    height: 270px
}
.h-\[3\.75rem\] {
    height: 3.75rem
}
.max-h-80 {
    max-height: 20rem
}
.max-h-full {
    max-height: 100%
}
.max-h-96 {
    max-height: 24rem
}
.max-h-\[223px\] {
    max-height: 223px
}
.max-h-\[470px\] {
    max-height: 470px
}
.max-h-\[4\.2em\] {
    max-height: 4.2em
}
.max-h-\[100\%\] {
    max-height: 100%
}
.max-h-\[5\.2rem\] {
    max-height: 5.2rem
}
.min-h-full {
    min-height: 100%
}
.min-h-\[49px\] {
    min-height: 49px
}
.min-h-\[164px\] {
    min-height: 164px
}
.min-h-\[400px\] {
    min-height: 400px
}
.min-h-\[300px\] {
    min-height: 300px
}
.min-h-\[370px\] {
    min-height: 370px
}
.min-h-\[556px\] {
    min-height: 556px
}
.min-h-\[410px\] {
    min-height: 410px
}
.min-h-\[363px\] {
    min-height: 363px
}
.min-h-\[752px\] {
    min-height: 752px
}
.min-h-\[150px\] {
    min-height: 150px
}
.min-h-\[432px\] {
    min-height: 432px
}
.min-h-\[225px\] {
    min-height: 225px
}
.min-h-\[5rem\] {
    min-height: 5rem
}
.w-0 {
    width: 0px
}
.w-1 {
    width: 0.25rem
}
.w-2 {
    width: 0.5rem
}
.w-3 {
    width: 0.75rem
}
.w-4 {
    width: 1rem
}
.w-5 {
    width: 1.25rem
}
.w-6 {
    width: 1.5rem
}
.w-7 {
    width: 1.75rem
}
.w-8 {
    width: 2rem
}
.w-9 {
    width: 2.25rem
}
.w-10 {
    width: 2.5rem
}
.w-11 {
    width: 2.75rem
}
.w-12 {
    width: 3rem
}
.w-14 {
    width: 3.5rem
}
.w-16 {
    width: 4rem
}
.w-20 {
    width: 5rem
}
.w-24 {
    width: 6rem
}
.w-28 {
    width: 7rem
}
.w-32 {
    width: 8rem
}
.w-36 {
    width: 9rem
}
.w-40 {
    width: 10rem
}
.w-44 {
    width: 11rem
}
.w-48 {
    width: 12rem
}
.w-52 {
    width: 13rem
}
.w-56 {
    width: 14rem
}
.w-60 {
    width: 15rem
}
.w-64 {
    width: 16rem
}
.w-72 {
    width: 18rem
}
.w-80 {
    width: 20rem
}
.w-96 {
    width: 24rem
}
.w-px {
    width: 1px
}
.w-0\.5 {
    width: 0.125rem
}
.w-1\.5 {
    width: 0.375rem
}
.w-2\.5 {
    width: 0.625rem
}
.w-3\.5 {
    width: 0.875rem
}
.w-full {
    width: 100%
}
.w-1\/2 {
    width: 50%
}
.w-full-screen-w {
    width: 100vw
}
.w-auto {
    width: auto
}
.w-fit {
    width: -moz-fit-content;
    width: fit-content
}
.w-max {
    width: -moz-max-content;
    width: max-content
}
.w-min {
    width: -moz-min-content;
    width: min-content
}
.w-9\/12 {
    width: 75%
}
.w-\[85\%\] {
    width: 85%
}
.w-\[40px\] {
    width: 40px
}
.w-\[90\%\] {
    width: 90%
}
.w-\[83\%\] {
    width: 83%
}
.w-\[35px\] {
    width: 35px
}
.w-\[17px\] {
    width: 17px
}
.w-\[117px\] {
    width: 117px
}
.w-\[88px\] {
    width: 88px
}
.w-\[55\%\] {
    width: 55%
}
.w-3\/5 {
    width: 60%
}
.w-\[50px\] {
    width: 50px
}
.w-10\/12 {
    width: 83.333333%
}
.w-4\/5 {
    width: 80%
}
.w-\[70\%\] {
    width: 70%
}
.w-\[6px\] {
    width: 6px
}
.w-\[30\%\] {
    width: 30%
}
.w-\[250px\] {
    width: 250px
}
.w-\[115px\] {
    width: 115px
}
.w-\[100\%\] {
    width: 100%
}
.w-3\/6 {
    width: 50%
}
.w-\[0\.75rem\] {
    width: 0.75rem
}
.w-\[0\.65rem\] {
    width: 0.65rem
}
.w-\[3\.75rem\] {
    width: 3.75rem
}
.w-2\/3 {
    width: 66.666667%
}
.min-w-\[50px\] {
    min-width: 50px
}
.min-w-\[90\%\] {
    min-width: 90%
}
.min-w-\[8\.8rem\] {
    min-width: 8.8rem
}
.min-w-\[32px\] {
    min-width: 32px
}
.min-w-\[12rem\] {
    min-width: 12rem
}
.max-w-full-screen-w {
    max-width: 100vw
}
.max-w-full {
    max-width: 100%
}
.max-w-4xl {
    max-width: 56rem
}
.max-w-\[70\%\] {
    max-width: 70%
}
.max-w-\[696px\] {
    max-width: 696px
}
.max-w-\[200px\] {
    max-width: 200px
}
.max-w-\[100\%\] {
    max-width: 100%
}
.max-w-\[600px\] {
    max-width: 600px
}
.max-w-\[228px\] {
    max-width: 228px
}
.max-w-\[700px\] {
    max-width: 700px
}
.max-w-\[50\%\] {
    max-width: 50%
}
.flex-shrink-0 {
    flex-shrink: 0
}
.flex-shrink {
    flex-shrink: 1
}
.shrink {
    flex-shrink: 1
}
.flex-grow {
    flex-grow: 1
}
.flex-grow-0 {
    flex-grow: 0
}
.grow {
    flex-grow: 1
}
.table-auto {
    table-layout: auto
}
.border-collapse {
    border-collapse: collapse
}
.translate-y-1\/2 {
    --tw-translate-y: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.translate-x-\[5\%\] {
    --tw-translate-x: 5%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.translate-y-2\/4 {
    --tw-translate-y: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
.cursor-pointer {
    cursor: pointer
}
.cursor-not-allowed {
    cursor: not-allowed
}
.cursor-default {
    cursor: default
}
.select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none
}
.resize {
    resize: both
}
.list-none {
    list-style-type: none
}
.appearance-none {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none
}
.columns-lg {
    -moz-columns: 32rem;
         columns: 32rem
}
.columns-md {
    -moz-columns: 28rem;
         columns: 28rem
}
.columns-sm {
    -moz-columns: 24rem;
         columns: 24rem
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr))
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr))
}
.grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr))
}
.grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr))
}
.grid-cols-\[1fr\] {
    grid-template-columns: 1fr
}
.grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr))
}
.grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr))
}
.grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr))
}
.grid-rows-\[auto\] {
    grid-template-rows: auto
}
.grid-rows-\[auto_auto\] {
    grid-template-rows: auto auto
}
.flex-row {
    flex-direction: row
}
.flex-row-reverse {
    flex-direction: row-reverse
}
.flex-col {
    flex-direction: column
}
.flex-wrap {
    flex-wrap: wrap
}
.flex-nowrap {
    flex-wrap: nowrap
}
.place-content-center {
    place-content: center
}
.place-content-between {
    place-content: space-between
}
.place-items-center {
    place-items: center
}
.place-items-stretch {
    place-items: stretch
}
.content-center {
    align-content: center
}
.content-start {
    align-content: flex-start
}
.items-start {
    align-items: flex-start
}
.items-end {
    align-items: flex-end
}
.items-center {
    align-items: center
}
.items-stretch {
    align-items: stretch
}
.justify-start {
    justify-content: flex-start
}
.justify-end {
    justify-content: flex-end
}
.justify-center {
    justify-content: center
}
.justify-between {
    justify-content: space-between
}
.justify-around {
    justify-content: space-around
}
.justify-items-start {
    justify-items: start
}
.justify-items-center {
    justify-items: center
}
.gap-6 {
    gap: 1.5rem
}
.gap-2 {
    gap: 0.5rem
}
.gap-3 {
    gap: 0.75rem
}
.gap-8 {
    gap: 2rem
}
.gap-1 {
    gap: 0.25rem
}
.gap-4 {
    gap: 1rem
}
.gap-10 {
    gap: 2.5rem
}
.gap-0 {
    gap: 0px
}
.gap-\[5\%\] {
    gap: 5%
}
.gap-2\.5 {
    gap: 0.625rem
}
.gap-y-16 {
    row-gap: 4rem
}
.gap-y-10 {
    row-gap: 2.5rem
}
.gap-y-6 {
    row-gap: 1.5rem
}
.gap-y-4 {
    row-gap: 1rem
}
.gap-x-12 {
    -moz-column-gap: 3rem;
         column-gap: 3rem
}
.gap-y-3 {
    row-gap: 0.75rem
}
.gap-y-2 {
    row-gap: 0.5rem
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)))
}
.place-self-center {
    place-self: center
}
.place-self-stretch {
    place-self: stretch
}
.self-start {
    align-self: flex-start
}
.self-end {
    align-self: flex-end
}
.self-center {
    align-self: center
}
.justify-self-start {
    justify-self: start
}
.justify-self-end {
    justify-self: end
}
.overflow-auto {
    overflow: auto
}
.overflow-hidden {
    overflow: hidden
}
.overflow-visible {
    overflow: visible
}
.overflow-y-auto {
    overflow-y: auto
}
.overflow-x-scroll {
    overflow-x: scroll
}
.overflow-y-scroll {
    overflow-y: scroll
}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}
.text-ellipsis {
    text-overflow: ellipsis
}
.whitespace-normal {
    white-space: normal
}
.whitespace-nowrap {
    white-space: nowrap
}
.whitespace-pre-wrap {
    white-space: pre-wrap
}
.break-words {
    overflow-wrap: break-word
}
.rounded-md {
    border-radius: 0.375rem
}
.rounded-xl {
    border-radius: 0.75rem
}
.rounded {
    border-radius: 0.25rem
}
.rounded-sm {
    border-radius: 0.125rem
}
.rounded-full {
    border-radius: 9999px
}
.rounded-lg {
    border-radius: 0.5rem
}
.rounded-none {
    border-radius: 0px
}
.rounded-3xl {
    border-radius: 1.5rem
}
.rounded-2xl {
    border-radius: 1rem
}
.rounded-\[60px\] {
    border-radius: 60px
}
.rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem
}
.rounded-b-none {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px
}
.border {
    border-width: 1px
}
.border-0 {
    border-width: 0px
}
.border-2 {
    border-width: 2px
}
.border-4 {
    border-width: 4px
}
.border-\[0px\] {
    border-width: 0px
}
.border-\[1px\] {
    border-width: 1px
}
.border-\[1\.5px\] {
    border-width: 1.5px
}
.border-\[3px\] {
    border-width: 3px
}
.border-b {
    border-bottom-width: 1px
}
.border-l-8 {
    border-left-width: 8px
}
.border-t-2 {
    border-top-width: 2px
}
.border-t-0 {
    border-top-width: 0px
}
.border-b-2 {
    border-bottom-width: 2px
}
.border-l-2 {
    border-left-width: 2px
}
.border-r-0 {
    border-right-width: 0px
}
.border-l-0 {
    border-left-width: 0px
}
.border-b-4 {
    border-bottom-width: 4px
}
.border-r-2 {
    border-right-width: 2px
}
.border-b-0 {
    border-bottom-width: 0px
}
.border-t-\[3px\] {
    border-top-width: 3px
}
.border-solid {
    border-style: solid
}
.border-dashed {
    border-style: dashed
}
.border-none {
    border-style: none
}
.border-outline-phase2-blue {
    border-color: var(--outline-phase2-blue)
}
.border-outline-karma-coral {
    border-color: var(--outline-karma-coral)
}
.border-outline-soft-black {
    border-color: var(--outline-soft-black)
}
.border-outline-not-gray {
    border-color: var(--outline-not-gray)
}
.border-outline-transparent {
    border-color: var(--outline-transparent)
}
.border-outline-white {
    border-color: var(--outline-white)
}
.border-outline-black {
    border-color: var(--outline-black)
}
.border-outline-dark-blue {
    border-color: var(--outline-dark-blue)
}
.border-outline-medium-blue {
    border-color: var(--outline-medium-blue)
}
.border-outline-light-blue {
    border-color: var(--outline-light-blue)
}
.border-outline-dark-gray {
    border-color: var(--outline-dark-gray)
}
.border-outline-medium-gray {
    border-color: var(--outline-medium-gray)
}
.border-outline-light-gray {
    border-color: var(--outline-light-gray)
}
.border-outline-misty-teal {
    border-color: var(--outline-misty-teal)
}
.border-outline-electric-violet {
    border-color: var(--outline-electric-violet)
}
.border-outline-dusty-blue {
    border-color: var(--outline-dusty-blue)
}
.border-blue-responsible-darken-1 {
    border-color: var(--blue-responsible-darken-1)
}
.border-blue-responsible-darken-2 {
    border-color: var(--blue-responsible-darken-2)
}
.border-blue-responsible-main {
    border-color: var(--blue-responsible-main)
}
.border-blue-responsible-lighten-1 {
    border-color: var(--blue-responsible-lighten-1)
}
.border-blue-responsible-lighten-2 {
    border-color: var(--blue-responsible-lighten-2)
}
.border-blue-responsible-lighten-3 {
    border-color: var(--blue-responsible-lighten-3)
}
.border-blue-responsible-lighten-4 {
    border-color: var(--blue-responsible-lighten-4)
}
.border-blue-responsible-lighten-5 {
    border-color: var(--blue-responsible-lighten-5)
}
.border-blue-responsible-lighten-6 {
    border-color: var(--blue-responsible-lighten-6)
}
.border-gray-professional-darken-1 {
    border-color: var(--gray-professional-darken-1)
}
.border-gray-professional-darken-2 {
    border-color: var(--gray-professional-darken-2)
}
.border-gray-professional-main {
    border-color: var(--gray-professional-main)
}
.border-gray-professional-lighten-1 {
    border-color: var(--gray-professional-lighten-1)
}
.border-gray-professional-lighten-2 {
    border-color: var(--gray-professional-lighten-2)
}
.border-gray-professional-lighten-3 {
    border-color: var(--gray-professional-lighten-3)
}
.border-gray-professional-lighten-4 {
    border-color: var(--gray-professional-lighten-4)
}
.border-gray-professional-lighten-5 {
    border-color: var(--gray-professional-lighten-5)
}
.border-cyan-near-darken-1 {
    border-color: var(--cyan-near-darken-1)
}
.border-cyan-near-darken-2 {
    border-color: var(--cyan-near-darken-2)
}
.border-cyan-near-main {
    border-color: var(--cyan-near-main)
}
.border-cyan-near-lighten-1 {
    border-color: var(--cyan-near-lighten-1)
}
.border-cyan-near-lighten-2 {
    border-color: var(--cyan-near-lighten-2)
}
.border-cyan-near-lighten-3 {
    border-color: var(--cyan-near-lighten-3)
}
.border-cyan-near-lighten-4 {
    border-color: var(--cyan-near-lighten-4)
}
.border-cyan-near-lighten-5 {
    border-color: var(--cyan-near-lighten-5)
}
.border-green-guarantee-darken-1 {
    border-color: var(--green-guarantee-darken-1)
}
.border-green-guarantee-darken-2 {
    border-color: var(--green-guarantee-darken-2)
}
.border-green-guarantee-main {
    border-color: var(--green-guarantee-main)
}
.border-green-guarantee-lighten-1 {
    border-color: var(--green-guarantee-lighten-1)
}
.border-green-guarantee-lighten-2 {
    border-color: var(--green-guarantee-lighten-2)
}
.border-green-guarantee-lighten-3 {
    border-color: var(--green-guarantee-lighten-3)
}
.border-green-guarantee-lighten-4 {
    border-color: var(--green-guarantee-lighten-4)
}
.border-green-guarantee-lighten-5 {
    border-color: var(--green-guarantee-lighten-5)
}
.border-gray-cosmopolitan-darken-1 {
    border-color: var(--gray-cosmopolitan-darken-1)
}
.border-gray-cosmopolitan-darken-2 {
    border-color: var(--gray-cosmopolitan-darken-2)
}
.border-gray-cosmopolitan-main {
    border-color: var(--gray-cosmopolitan-main)
}
.border-gray-cosmopolitan-lighten-1 {
    border-color: var(--gray-cosmopolitan-lighten-1)
}
.border-gray-cosmopolitan-lighten-2 {
    border-color: var(--gray-cosmopolitan-lighten-2)
}
.border-gray-cosmopolitan-lighten-3 {
    border-color: var(--gray-cosmopolitan-lighten-3)
}
.border-gray-cosmopolitan-lighten-4 {
    border-color: var(--gray-cosmopolitan-lighten-4)
}
.border-gray-cosmopolitan-lighten-5 {
    border-color: var(--gray-cosmopolitan-lighten-5)
}
.border-green-quality-darken-1 {
    border-color: var(--green-quality-darken-1)
}
.border-green-quality-darken-2 {
    border-color: var(--green-quality-darken-2)
}
.border-green-quality-main {
    border-color: var(--green-quality-main)
}
.border-green-quality-lighten-1 {
    border-color: var(--green-quality-lighten-1)
}
.border-green-quality-lighten-2 {
    border-color: var(--green-quality-lighten-2)
}
.border-green-quality-lighten-3 {
    border-color: var(--green-quality-lighten-3)
}
.border-green-quality-lighten-4 {
    border-color: var(--green-quality-lighten-4)
}
.border-green-quality-lighten-5 {
    border-color: var(--green-quality-lighten-5)
}
.border-yellow-knowledge-darken-1 {
    border-color: var(--yellow-knowledge-darken-1)
}
.border-yellow-knowledge-darken-2 {
    border-color: var(--yellow-knowledge-darken-2)
}
.border-yellow-knowledge-main {
    border-color: var(--yellow-knowledge-main)
}
.border-yellow-knowledge-lighten-1 {
    border-color: var(--yellow-knowledge-lighten-1)
}
.border-yellow-knowledge-lighten-2 {
    border-color: var(--yellow-knowledge-lighten-2)
}
.border-yellow-knowledge-lighten-3 {
    border-color: var(--yellow-knowledge-lighten-3)
}
.border-yellow-knowledge-lighten-4 {
    border-color: var(--yellow-knowledge-lighten-4)
}
.border-yellow-knowledge-lighten-5 {
    border-color: var(--yellow-knowledge-lighten-5)
}
.border-orange-darken-1 {
    border-color: var(--orange-darken-1)
}
.border-orange-darken-2 {
    border-color: var(--orange-darken-2)
}
.border-orange-main {
    border-color: var(--orange-main)
}
.border-orange-lighten-1 {
    border-color: var(--orange-lighten-1)
}
.border-orange-lighten-2 {
    border-color: var(--orange-lighten-2)
}
.border-orange-lighten-3 {
    border-color: var(--orange-lighten-3)
}
.border-orange-lighten-4 {
    border-color: var(--orange-lighten-4)
}
.border-orange-lighten-5 {
    border-color: var(--orange-lighten-5)
}
.border-purple-new-darken-1 {
    border-color: var(--purple-new-darken-1)
}
.border-purple-new-darken-2 {
    border-color: var(--purple-new-darken-2)
}
.border-purple-new-main {
    border-color: var(--purple-new-main)
}
.border-purple-new-lighten-1 {
    border-color: var(--purple-new-lighten-1)
}
.border-purple-new-lighten-2 {
    border-color: var(--purple-new-lighten-2)
}
.border-purple-new-lighten-3 {
    border-color: var(--purple-new-lighten-3)
}
.border-purple-new-lighten-4 {
    border-color: var(--purple-new-lighten-4)
}
.border-purple-new-lighten-5 {
    border-color: var(--purple-new-lighten-5)
}
.border-neutral-transparent {
    border-color: var(--neutral-transparent)
}
.border-neutral-white {
    border-color: var(--neutral-white)
}
.border-neutral-grayLight {
    border-color: var(--neutral-grayLight)
}
.border-neutral-grayMedium {
    border-color: var(--neutral-grayMedium)
}
.border-neutral-grayDark {
    border-color: var(--neutral-grayDark)
}
.border-neutral-black {
    border-color: var(--neutral-black)
}
.border-custom-salesforce-blue {
    border-color: var(--salesforce-blue)
}
.border-custom-performance-orange {
    border-color: var(--performance-orange)
}
.border-custom-performance-blue {
    border-color: var(--performance-blue)
}
.border-custom-performance-red {
    border-color: var(--status-error)
}
.border-custom-performance-light-blue {
    border-color: var(--performance-light-blue)
}
.border-custom-performance-light-white {
    border-color: var(--performance-light-white)
}
.border-custom-performance-gray {
    border-color: var(--performance-gray)
}
.border-custom-performance-gray-2 {
    border-color: var(--performance-gray-2)
}
.border-ui-error {
    border-color: var(--ui-errorBackground)
}
.border-ui-warning {
    border-color: var(--ui-warningBackground)
}
.border-ui-info {
    border-color: var(--ui-infoBackground)
}
.border-ui-success {
    border-color: var(--ui-successBackground)
}
.border-ui-errorText {
    border-color: var(--ui-errorText)
}
.border-ui-warningText {
    border-color: var(--ui-warningText)
}
.border-ui-infoText {
    border-color: var(--ui-infoText)
}
.border-ui-successText {
    border-color: var(--ui-successText)
}
.border-demo-white {
    border-color: var(--demo-white)
}
.border-demo-black {
    border-color: var(--demo-black)
}
.border-demo-darkBlue {
    border-color: var(--demo-darkBlue)
}
.border-demo-mediumBlue {
    border-color: var(--demo-mediumBlue)
}
.border-demo-lightBlue {
    border-color: var(--demo-lightBlue)
}
.border-demo-darkGray {
    border-color: var(--demo-darkGray)
}
.border-demo-mediumGray {
    border-color: var(--demo-mediumGray)
}
.border-demo-lightGray {
    border-color: var(--demo-lightGray)
}
.border-t-green-guarantee-lighten-2 {
    border-top-color: var(--green-guarantee-lighten-2)
}
.border-b-demo-darkGray {
    border-bottom-color: var(--demo-darkGray)
}
.bg-outline-phase2-blue {
    background-color: var(--outline-phase2-blue)
}
.bg-outline-karma-coral {
    background-color: var(--outline-karma-coral)
}
.bg-outline-soft-black {
    background-color: var(--outline-soft-black)
}
.bg-outline-not-gray {
    background-color: var(--outline-not-gray)
}
.bg-outline-transparent {
    background-color: var(--outline-transparent)
}
.bg-outline-white {
    background-color: var(--outline-white)
}
.bg-outline-black {
    background-color: var(--outline-black)
}
.bg-outline-dark-blue {
    background-color: var(--outline-dark-blue)
}
.bg-outline-medium-blue {
    background-color: var(--outline-medium-blue)
}
.bg-outline-light-blue {
    background-color: var(--outline-light-blue)
}
.bg-outline-dark-gray {
    background-color: var(--outline-dark-gray)
}
.bg-outline-medium-gray {
    background-color: var(--outline-medium-gray)
}
.bg-outline-light-gray {
    background-color: var(--outline-light-gray)
}
.bg-outline-misty-teal {
    background-color: var(--outline-misty-teal)
}
.bg-outline-electric-violet {
    background-color: var(--outline-electric-violet)
}
.bg-outline-dusty-blue {
    background-color: var(--outline-dusty-blue)
}
.bg-blue-responsible-darken-1 {
    background-color: var(--blue-responsible-darken-1)
}
.bg-blue-responsible-darken-2 {
    background-color: var(--blue-responsible-darken-2)
}
.bg-blue-responsible-main {
    background-color: var(--blue-responsible-main)
}
.bg-blue-responsible-lighten-1 {
    background-color: var(--blue-responsible-lighten-1)
}
.bg-blue-responsible-lighten-2 {
    background-color: var(--blue-responsible-lighten-2)
}
.bg-blue-responsible-lighten-3 {
    background-color: var(--blue-responsible-lighten-3)
}
.bg-blue-responsible-lighten-4 {
    background-color: var(--blue-responsible-lighten-4)
}
.bg-blue-responsible-lighten-5 {
    background-color: var(--blue-responsible-lighten-5)
}
.bg-blue-responsible-lighten-6 {
    background-color: var(--blue-responsible-lighten-6)
}
.bg-gray-professional-darken-1 {
    background-color: var(--gray-professional-darken-1)
}
.bg-gray-professional-darken-2 {
    background-color: var(--gray-professional-darken-2)
}
.bg-gray-professional-main {
    background-color: var(--gray-professional-main)
}
.bg-gray-professional-lighten-1 {
    background-color: var(--gray-professional-lighten-1)
}
.bg-gray-professional-lighten-2 {
    background-color: var(--gray-professional-lighten-2)
}
.bg-gray-professional-lighten-3 {
    background-color: var(--gray-professional-lighten-3)
}
.bg-gray-professional-lighten-4 {
    background-color: var(--gray-professional-lighten-4)
}
.bg-gray-professional-lighten-5 {
    background-color: var(--gray-professional-lighten-5)
}
.bg-cyan-near-darken-1 {
    background-color: var(--cyan-near-darken-1)
}
.bg-cyan-near-darken-2 {
    background-color: var(--cyan-near-darken-2)
}
.bg-cyan-near-main {
    background-color: var(--cyan-near-main)
}
.bg-cyan-near-lighten-1 {
    background-color: var(--cyan-near-lighten-1)
}
.bg-cyan-near-lighten-2 {
    background-color: var(--cyan-near-lighten-2)
}
.bg-cyan-near-lighten-3 {
    background-color: var(--cyan-near-lighten-3)
}
.bg-cyan-near-lighten-4 {
    background-color: var(--cyan-near-lighten-4)
}
.bg-cyan-near-lighten-5 {
    background-color: var(--cyan-near-lighten-5)
}
.bg-green-guarantee-darken-1 {
    background-color: var(--green-guarantee-darken-1)
}
.bg-green-guarantee-darken-2 {
    background-color: var(--green-guarantee-darken-2)
}
.bg-green-guarantee-main {
    background-color: var(--green-guarantee-main)
}
.bg-green-guarantee-lighten-1 {
    background-color: var(--green-guarantee-lighten-1)
}
.bg-green-guarantee-lighten-2 {
    background-color: var(--green-guarantee-lighten-2)
}
.bg-green-guarantee-lighten-3 {
    background-color: var(--green-guarantee-lighten-3)
}
.bg-green-guarantee-lighten-4 {
    background-color: var(--green-guarantee-lighten-4)
}
.bg-green-guarantee-lighten-5 {
    background-color: var(--green-guarantee-lighten-5)
}
.bg-gray-cosmopolitan-darken-1 {
    background-color: var(--gray-cosmopolitan-darken-1)
}
.bg-gray-cosmopolitan-darken-2 {
    background-color: var(--gray-cosmopolitan-darken-2)
}
.bg-gray-cosmopolitan-main {
    background-color: var(--gray-cosmopolitan-main)
}
.bg-gray-cosmopolitan-lighten-1 {
    background-color: var(--gray-cosmopolitan-lighten-1)
}
.bg-gray-cosmopolitan-lighten-2 {
    background-color: var(--gray-cosmopolitan-lighten-2)
}
.bg-gray-cosmopolitan-lighten-3 {
    background-color: var(--gray-cosmopolitan-lighten-3)
}
.bg-gray-cosmopolitan-lighten-4 {
    background-color: var(--gray-cosmopolitan-lighten-4)
}
.bg-gray-cosmopolitan-lighten-5 {
    background-color: var(--gray-cosmopolitan-lighten-5)
}
.bg-green-quality-darken-1 {
    background-color: var(--green-quality-darken-1)
}
.bg-green-quality-darken-2 {
    background-color: var(--green-quality-darken-2)
}
.bg-green-quality-main {
    background-color: var(--green-quality-main)
}
.bg-green-quality-lighten-1 {
    background-color: var(--green-quality-lighten-1)
}
.bg-green-quality-lighten-2 {
    background-color: var(--green-quality-lighten-2)
}
.bg-green-quality-lighten-3 {
    background-color: var(--green-quality-lighten-3)
}
.bg-green-quality-lighten-4 {
    background-color: var(--green-quality-lighten-4)
}
.bg-green-quality-lighten-5 {
    background-color: var(--green-quality-lighten-5)
}
.bg-yellow-knowledge-darken-1 {
    background-color: var(--yellow-knowledge-darken-1)
}
.bg-yellow-knowledge-darken-2 {
    background-color: var(--yellow-knowledge-darken-2)
}
.bg-yellow-knowledge-main {
    background-color: var(--yellow-knowledge-main)
}
.bg-yellow-knowledge-lighten-1 {
    background-color: var(--yellow-knowledge-lighten-1)
}
.bg-yellow-knowledge-lighten-2 {
    background-color: var(--yellow-knowledge-lighten-2)
}
.bg-yellow-knowledge-lighten-3 {
    background-color: var(--yellow-knowledge-lighten-3)
}
.bg-yellow-knowledge-lighten-4 {
    background-color: var(--yellow-knowledge-lighten-4)
}
.bg-yellow-knowledge-lighten-5 {
    background-color: var(--yellow-knowledge-lighten-5)
}
.bg-orange-darken-1 {
    background-color: var(--orange-darken-1)
}
.bg-orange-darken-2 {
    background-color: var(--orange-darken-2)
}
.bg-orange-main {
    background-color: var(--orange-main)
}
.bg-orange-lighten-1 {
    background-color: var(--orange-lighten-1)
}
.bg-orange-lighten-2 {
    background-color: var(--orange-lighten-2)
}
.bg-orange-lighten-3 {
    background-color: var(--orange-lighten-3)
}
.bg-orange-lighten-4 {
    background-color: var(--orange-lighten-4)
}
.bg-orange-lighten-5 {
    background-color: var(--orange-lighten-5)
}
.bg-purple-new-darken-1 {
    background-color: var(--purple-new-darken-1)
}
.bg-purple-new-darken-2 {
    background-color: var(--purple-new-darken-2)
}
.bg-purple-new-main {
    background-color: var(--purple-new-main)
}
.bg-purple-new-lighten-1 {
    background-color: var(--purple-new-lighten-1)
}
.bg-purple-new-lighten-2 {
    background-color: var(--purple-new-lighten-2)
}
.bg-purple-new-lighten-3 {
    background-color: var(--purple-new-lighten-3)
}
.bg-purple-new-lighten-4 {
    background-color: var(--purple-new-lighten-4)
}
.bg-purple-new-lighten-5 {
    background-color: var(--purple-new-lighten-5)
}
.bg-neutral-transparent {
    background-color: var(--neutral-transparent)
}
.bg-neutral-white {
    background-color: var(--neutral-white)
}
.bg-neutral-grayLight {
    background-color: var(--neutral-grayLight)
}
.bg-neutral-grayMedium {
    background-color: var(--neutral-grayMedium)
}
.bg-neutral-grayDark {
    background-color: var(--neutral-grayDark)
}
.bg-neutral-black {
    background-color: var(--neutral-black)
}
.bg-custom-salesforce-blue {
    background-color: var(--salesforce-blue)
}
.bg-custom-performance-orange {
    background-color: var(--performance-orange)
}
.bg-custom-performance-blue {
    background-color: var(--performance-blue)
}
.bg-custom-performance-red {
    background-color: var(--status-error)
}
.bg-custom-performance-light-blue {
    background-color: var(--performance-light-blue)
}
.bg-custom-performance-light-white {
    background-color: var(--performance-light-white)
}
.bg-custom-performance-gray {
    background-color: var(--performance-gray)
}
.bg-custom-performance-gray-2 {
    background-color: var(--performance-gray-2)
}
.bg-ui-error {
    background-color: var(--ui-errorBackground)
}
.bg-ui-warning {
    background-color: var(--ui-warningBackground)
}
.bg-ui-info {
    background-color: var(--ui-infoBackground)
}
.bg-ui-success {
    background-color: var(--ui-successBackground)
}
.bg-ui-errorText {
    background-color: var(--ui-errorText)
}
.bg-ui-warningText {
    background-color: var(--ui-warningText)
}
.bg-ui-infoText {
    background-color: var(--ui-infoText)
}
.bg-ui-successText {
    background-color: var(--ui-successText)
}
.bg-demo-white {
    background-color: var(--demo-white)
}
.bg-demo-black {
    background-color: var(--demo-black)
}
.bg-demo-darkBlue {
    background-color: var(--demo-darkBlue)
}
.bg-demo-mediumBlue {
    background-color: var(--demo-mediumBlue)
}
.bg-demo-lightBlue {
    background-color: var(--demo-lightBlue)
}
.bg-demo-darkGray {
    background-color: var(--demo-darkGray)
}
.bg-demo-mediumGray {
    background-color: var(--demo-mediumGray)
}
.bg-demo-lightGray {
    background-color: var(--demo-lightGray)
}
.bg-\[\#D4E5B3\] {
    --tw-bg-opacity: 1;
    background-color: rgb(212 229 179 / var(--tw-bg-opacity))
}
.bg-opacity-60 {
    --tw-bg-opacity: 0.6
}
.bg-none {
    background-image: none
}
.bg-cover {
    background-size: cover
}
.bg-center {
    background-position: center
}
.bg-no-repeat {
    background-repeat: no-repeat
}
.fill-cyan-near-main {
    fill: var(--cyan-near-main)
}
.fill-neutral-white {
    fill: var(--neutral-white)
}
.fill-\[none\] {
    fill: none
}
.stroke-cyan-near-main {
    stroke: var(--cyan-near-main)
}
.stroke-neutral-white {
    stroke: var(--neutral-white)
}
.stroke-2 {
    stroke-width: 2
}
.object-contain {
    object-fit: contain
}
.object-cover {
    object-fit: cover
}
.object-center {
    object-position: center
}
.p-12 {
    padding: 3rem
}
.p-4 {
    padding: 1rem
}
.p-6 {
    padding: 1.5rem
}
.p-8 {
    padding: 2rem
}
.p-0 {
    padding: 0px
}
.p-2 {
    padding: 0.5rem
}
.p-5 {
    padding: 1.25rem
}
.p-1 {
    padding: 0.25rem
}
.p-3 {
    padding: 0.75rem
}
.p-1\.5 {
    padding: 0.375rem
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px
}
.px-8 {
    padding-left: 2rem;
    padding-right: 2rem
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem
}
.py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem
}
.py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem
}
.py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem
}
.py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem
}
.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem
}
.px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem
}
.px-0 {
    padding-left: 0px;
    padding-right: 0px
}
.px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem
}
.px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem
}
.px-16 {
    padding-left: 4rem;
    padding-right: 4rem
}
.py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem
}
.px-12 {
    padding-left: 3rem;
    padding-right: 3rem
}
.px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem
}
.py-px {
    padding-top: 1px;
    padding-bottom: 1px
}
.py-\[0\.7rem\] {
    padding-top: 0.7rem;
    padding-bottom: 0.7rem
}
.px-\[1em\] {
    padding-left: 1em;
    padding-right: 1em
}
.px-\[0\.6rem\] {
    padding-left: 0.6rem;
    padding-right: 0.6rem
}
.pl-8 {
    padding-left: 2rem
}
.pr-0 {
    padding-right: 0px
}
.pl-4 {
    padding-left: 1rem
}
.pr-2 {
    padding-right: 0.5rem
}
.pb-2 {
    padding-bottom: 0.5rem
}
.pt-4 {
    padding-top: 1rem
}
.pb-16 {
    padding-bottom: 4rem
}
.pl-5 {
    padding-left: 1.25rem
}
.pt-10 {
    padding-top: 2.5rem
}
.pb-1 {
    padding-bottom: 0.25rem
}
.pb-12 {
    padding-bottom: 3rem
}
.pb-6 {
    padding-bottom: 1.5rem
}
.pt-14 {
    padding-top: 3.5rem
}
.pb-28 {
    padding-bottom: 7rem
}
.pb-3 {
    padding-bottom: 0.75rem
}
.pl-0 {
    padding-left: 0px
}
.pt-0 {
    padding-top: 0px
}
.pb-40 {
    padding-bottom: 10rem
}
.pl-3 {
    padding-left: 0.75rem
}
.pt-7 {
    padding-top: 1.75rem
}
.pr-3 {
    padding-right: 0.75rem
}
.pt-2 {
    padding-top: 0.5rem
}
.pl-6 {
    padding-left: 1.5rem
}
.pr-6 {
    padding-right: 1.5rem
}
.pb-8 {
    padding-bottom: 2rem
}
.pt-5 {
    padding-top: 1.25rem
}
.pt-6 {
    padding-top: 1.5rem
}
.pb-0 {
    padding-bottom: 0px
}
.pl-2 {
    padding-left: 0.5rem
}
.pl-1 {
    padding-left: 0.25rem
}
.pr-36 {
    padding-right: 9rem
}
.pt-8 {
    padding-top: 2rem
}
.pb-4 {
    padding-bottom: 1rem
}
.pt-1 {
    padding-top: 0.25rem
}
.pt-12 {
    padding-top: 3rem
}
.pb-10 {
    padding-bottom: 2.5rem
}
.pr-7 {
    padding-right: 1.75rem
}
.pr-5 {
    padding-right: 1.25rem
}
.pl-14 {
    padding-left: 3.5rem
}
.pt-9 {
    padding-top: 2.25rem
}
.pb-5 {
    padding-bottom: 1.25rem
}
.\!pl-4 {
    padding-left: 1rem !important
}
.\!pt-4 {
    padding-top: 1rem !important
}
.pt-\[1px\] {
    padding-top: 1px
}
.pr-\[20px\] {
    padding-right: 20px
}
.text-left {
    text-align: left
}
.text-center {
    text-align: center
}
.text-right {
    text-align: right
}
.indent-1 {
    text-indent: 0.25rem
}
.align-middle {
    vertical-align: middle
}
.align-bottom {
    vertical-align: bottom
}
.font-display {
    font-family: Open Sans, Helvetica, Arial, sans-serif
}
.font-body {
    font-family: Open Sans, Helvetica, Arial, sans-serif
}
.text-xxs {
    font-size: var(--fs-xxs);
    line-height: var(--lh-xxs)
}
.text-xs {
    font-size: var(--fs-xs);
    line-height: var(--lh-xs)
}
.text-sm {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm)
}
.text-base {
    font-size: var(--fs-base);
    line-height: var(--lh-base)
}
.text-lg {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg)
}
.text-xl {
    font-size: var(--fs-xl);
    line-height: var(--lh-xl)
}
.text-2xl {
    font-size: var(--fs-2xl);
    line-height: var(--lh-2xl)
}
.text-3xl {
    font-size: var(--fs-3xl);
    line-height: var(--lh-3xl)
}
.text-4xl {
    font-size: var(--fs-4xl);
    line-height: var(--lh-4xl)
}
.text-5xl {
    font-size: var(--fs-5xl);
    line-height: var(--lh-5xl)
}
.text-6xl {
    font-size: var(--fs-6xl);
    line-height: var(--lh-6xl)
}
.text-7xl {
    font-size: var(--fs-7xl);
    line-height: var(--lh-7xl)
}
.text-8xl {
    font-size: var(--fs-8xl);
    line-height: var(--lh-8xl)
}
.text-9xl {
    font-size: var(--fs-9xl);
    line-height: var(--lh-9lx)
}
.text-h1 {
    font-size: var(--fs-h1);
    line-height: var(--lh-h1)
}
.text-h1-small {
    font-size: var(--fs-h1-small);
    line-height: var(--lh-h1-small)
}
.text-h1-medium {
    font-size: var(--fs-h1-medium);
    line-height: var(--lh-h1-medium)
}
.text-h2 {
    font-size: var(--fs-h2);
    line-height: var(--lh-h2)
}
.text-h2-small {
    font-size: var(--fs-h2-small);
    line-height: var(--lh-h2-small)
}
.text-h2-medium {
    font-size: var(--fs-h2-medium);
    line-height: var(--lh-h2-medium)
}
.text-h3 {
    font-size: var(--fs-h3);
    line-height: var(--lh-h3)
}
.text-h3-small {
    font-size: var(--fs-h3-small);
    line-height: var(--lh-h3-small)
}
.text-h3-medium {
    font-size: var(--fs-h3-medium);
    line-height: var(--lh-h3-medium)
}
.text-h4 {
    font-size: var(--fs-h4);
    line-height: var(--lh-h4)
}
.text-h4-small {
    font-size: var(--fs-h4-small);
    line-height: var(--lh-h4-small)
}
.text-h4-medium {
    font-size: var(--fs-h4-medium);
    line-height: var(--lh-h4-medium)
}
.text-h5 {
    font-size: var(--fs-h5);
    line-height: var(--lh-h5)
}
.text-h5-small {
    font-size: var(--fs-h5-small);
    line-height: var(--lh-h5-small)
}
.text-h5-medium {
    font-size: var(--fs-h5-medium);
    line-height: var(--lh-h5-medium)
}
.text-h6 {
    font-size: var(--fs-h6);
    line-height: var(--lh-h6)
}
.text-h6-small {
    font-size: var(--fs-h6-small);
    line-height: var(--lh-h6-small)
}
.text-h6-medium {
    font-size: var(--fs-h6-medium);
    line-height: var(--lh-h6-medium)
}
.text-\[48px\] {
    font-size: 48px
}
.text-\[0\.875rem\] {
    font-size: 0.875rem
}
.font-thin {
    font-weight: var(--fw-extralight)
}
.font-extralight {
    font-weight: var(--fw-thin)
}
.font-light {
    font-weight: var(--fw-light)
}
.font-normal {
    font-weight: var(--fw-normal)
}
.font-medium {
    font-weight: var(--fw-medium)
}
.font-semibold {
    font-weight: var(--fw-semibold)
}
.font-bold {
    font-weight: var(--fw-bold)
}
.font-extrabold {
    font-weight: var(--fw-extrabold)
}
.font-black {
    font-weight: var(--fw-black)
}
.uppercase {
    text-transform: uppercase
}
.lowercase {
    text-transform: lowercase
}
.capitalize {
    text-transform: capitalize
}
.normal-case {
    text-transform: none
}
.italic {
    font-style: italic
}
.leading-5 {
    line-height: 1.25rem
}
.leading-tight {
    line-height: 1.25
}
.leading-normal {
    line-height: 1.5
}
.leading-none {
    line-height: 1
}
.tracking-wider {
    letter-spacing: 0.05em
}
.text-outline-phase2-blue {
    color: var(--outline-phase2-blue)
}
.text-outline-karma-coral {
    color: var(--outline-karma-coral)
}
.text-outline-soft-black {
    color: var(--outline-soft-black)
}
.text-outline-not-gray {
    color: var(--outline-not-gray)
}
.text-outline-transparent {
    color: var(--outline-transparent)
}
.text-outline-white {
    color: var(--outline-white)
}
.text-outline-black {
    color: var(--outline-black)
}
.text-outline-dark-blue {
    color: var(--outline-dark-blue)
}
.text-outline-medium-blue {
    color: var(--outline-medium-blue)
}
.text-outline-light-blue {
    color: var(--outline-light-blue)
}
.text-outline-dark-gray {
    color: var(--outline-dark-gray)
}
.text-outline-medium-gray {
    color: var(--outline-medium-gray)
}
.text-outline-light-gray {
    color: var(--outline-light-gray)
}
.text-outline-misty-teal {
    color: var(--outline-misty-teal)
}
.text-outline-electric-violet {
    color: var(--outline-electric-violet)
}
.text-outline-dusty-blue {
    color: var(--outline-dusty-blue)
}
.text-blue-responsible-darken-1 {
    color: var(--blue-responsible-darken-1)
}
.text-blue-responsible-darken-2 {
    color: var(--blue-responsible-darken-2)
}
.text-blue-responsible-main {
    color: var(--blue-responsible-main)
}
.text-blue-responsible-lighten-1 {
    color: var(--blue-responsible-lighten-1)
}
.text-blue-responsible-lighten-2 {
    color: var(--blue-responsible-lighten-2)
}
.text-blue-responsible-lighten-3 {
    color: var(--blue-responsible-lighten-3)
}
.text-blue-responsible-lighten-4 {
    color: var(--blue-responsible-lighten-4)
}
.text-blue-responsible-lighten-5 {
    color: var(--blue-responsible-lighten-5)
}
.text-blue-responsible-lighten-6 {
    color: var(--blue-responsible-lighten-6)
}
.text-gray-professional-darken-1 {
    color: var(--gray-professional-darken-1)
}
.text-gray-professional-darken-2 {
    color: var(--gray-professional-darken-2)
}
.text-gray-professional-main {
    color: var(--gray-professional-main)
}
.text-gray-professional-lighten-1 {
    color: var(--gray-professional-lighten-1)
}
.text-gray-professional-lighten-2 {
    color: var(--gray-professional-lighten-2)
}
.text-gray-professional-lighten-3 {
    color: var(--gray-professional-lighten-3)
}
.text-gray-professional-lighten-4 {
    color: var(--gray-professional-lighten-4)
}
.text-gray-professional-lighten-5 {
    color: var(--gray-professional-lighten-5)
}
.text-cyan-near-darken-1 {
    color: var(--cyan-near-darken-1)
}
.text-cyan-near-darken-2 {
    color: var(--cyan-near-darken-2)
}
.text-cyan-near-main {
    color: var(--cyan-near-main)
}
.text-cyan-near-lighten-1 {
    color: var(--cyan-near-lighten-1)
}
.text-cyan-near-lighten-2 {
    color: var(--cyan-near-lighten-2)
}
.text-cyan-near-lighten-3 {
    color: var(--cyan-near-lighten-3)
}
.text-cyan-near-lighten-4 {
    color: var(--cyan-near-lighten-4)
}
.text-cyan-near-lighten-5 {
    color: var(--cyan-near-lighten-5)
}
.text-green-guarantee-darken-1 {
    color: var(--green-guarantee-darken-1)
}
.text-green-guarantee-darken-2 {
    color: var(--green-guarantee-darken-2)
}
.text-green-guarantee-main {
    color: var(--green-guarantee-main)
}
.text-green-guarantee-lighten-1 {
    color: var(--green-guarantee-lighten-1)
}
.text-green-guarantee-lighten-2 {
    color: var(--green-guarantee-lighten-2)
}
.text-green-guarantee-lighten-3 {
    color: var(--green-guarantee-lighten-3)
}
.text-green-guarantee-lighten-4 {
    color: var(--green-guarantee-lighten-4)
}
.text-green-guarantee-lighten-5 {
    color: var(--green-guarantee-lighten-5)
}
.text-gray-cosmopolitan-darken-1 {
    color: var(--gray-cosmopolitan-darken-1)
}
.text-gray-cosmopolitan-darken-2 {
    color: var(--gray-cosmopolitan-darken-2)
}
.text-gray-cosmopolitan-main {
    color: var(--gray-cosmopolitan-main)
}
.text-gray-cosmopolitan-lighten-1 {
    color: var(--gray-cosmopolitan-lighten-1)
}
.text-gray-cosmopolitan-lighten-2 {
    color: var(--gray-cosmopolitan-lighten-2)
}
.text-gray-cosmopolitan-lighten-3 {
    color: var(--gray-cosmopolitan-lighten-3)
}
.text-gray-cosmopolitan-lighten-4 {
    color: var(--gray-cosmopolitan-lighten-4)
}
.text-gray-cosmopolitan-lighten-5 {
    color: var(--gray-cosmopolitan-lighten-5)
}
.text-green-quality-darken-1 {
    color: var(--green-quality-darken-1)
}
.text-green-quality-darken-2 {
    color: var(--green-quality-darken-2)
}
.text-green-quality-main {
    color: var(--green-quality-main)
}
.text-green-quality-lighten-1 {
    color: var(--green-quality-lighten-1)
}
.text-green-quality-lighten-2 {
    color: var(--green-quality-lighten-2)
}
.text-green-quality-lighten-3 {
    color: var(--green-quality-lighten-3)
}
.text-green-quality-lighten-4 {
    color: var(--green-quality-lighten-4)
}
.text-green-quality-lighten-5 {
    color: var(--green-quality-lighten-5)
}
.text-yellow-knowledge-darken-1 {
    color: var(--yellow-knowledge-darken-1)
}
.text-yellow-knowledge-darken-2 {
    color: var(--yellow-knowledge-darken-2)
}
.text-yellow-knowledge-main {
    color: var(--yellow-knowledge-main)
}
.text-yellow-knowledge-lighten-1 {
    color: var(--yellow-knowledge-lighten-1)
}
.text-yellow-knowledge-lighten-2 {
    color: var(--yellow-knowledge-lighten-2)
}
.text-yellow-knowledge-lighten-3 {
    color: var(--yellow-knowledge-lighten-3)
}
.text-yellow-knowledge-lighten-4 {
    color: var(--yellow-knowledge-lighten-4)
}
.text-yellow-knowledge-lighten-5 {
    color: var(--yellow-knowledge-lighten-5)
}
.text-orange-darken-1 {
    color: var(--orange-darken-1)
}
.text-orange-darken-2 {
    color: var(--orange-darken-2)
}
.text-orange-main {
    color: var(--orange-main)
}
.text-orange-lighten-1 {
    color: var(--orange-lighten-1)
}
.text-orange-lighten-2 {
    color: var(--orange-lighten-2)
}
.text-orange-lighten-3 {
    color: var(--orange-lighten-3)
}
.text-orange-lighten-4 {
    color: var(--orange-lighten-4)
}
.text-orange-lighten-5 {
    color: var(--orange-lighten-5)
}
.text-purple-new-darken-1 {
    color: var(--purple-new-darken-1)
}
.text-purple-new-darken-2 {
    color: var(--purple-new-darken-2)
}
.text-purple-new-main {
    color: var(--purple-new-main)
}
.text-purple-new-lighten-1 {
    color: var(--purple-new-lighten-1)
}
.text-purple-new-lighten-2 {
    color: var(--purple-new-lighten-2)
}
.text-purple-new-lighten-3 {
    color: var(--purple-new-lighten-3)
}
.text-purple-new-lighten-4 {
    color: var(--purple-new-lighten-4)
}
.text-purple-new-lighten-5 {
    color: var(--purple-new-lighten-5)
}
.text-neutral-transparent {
    color: var(--neutral-transparent)
}
.text-neutral-white {
    color: var(--neutral-white)
}
.text-neutral-grayLight {
    color: var(--neutral-grayLight)
}
.text-neutral-grayMedium {
    color: var(--neutral-grayMedium)
}
.text-neutral-grayDark {
    color: var(--neutral-grayDark)
}
.text-neutral-black {
    color: var(--neutral-black)
}
.text-custom-salesforce-blue {
    color: var(--salesforce-blue)
}
.text-custom-performance-orange {
    color: var(--performance-orange)
}
.text-custom-performance-blue {
    color: var(--performance-blue)
}
.text-custom-performance-red {
    color: var(--status-error)
}
.text-custom-performance-light-blue {
    color: var(--performance-light-blue)
}
.text-custom-performance-light-white {
    color: var(--performance-light-white)
}
.text-custom-performance-gray {
    color: var(--performance-gray)
}
.text-custom-performance-gray-2 {
    color: var(--performance-gray-2)
}
.text-ui-error {
    color: var(--ui-errorBackground)
}
.text-ui-warning {
    color: var(--ui-warningBackground)
}
.text-ui-info {
    color: var(--ui-infoBackground)
}
.text-ui-success {
    color: var(--ui-successBackground)
}
.text-ui-errorText {
    color: var(--ui-errorText)
}
.text-ui-warningText {
    color: var(--ui-warningText)
}
.text-ui-infoText {
    color: var(--ui-infoText)
}
.text-ui-successText {
    color: var(--ui-successText)
}
.text-demo-white {
    color: var(--demo-white)
}
.text-demo-black {
    color: var(--demo-black)
}
.text-demo-darkBlue {
    color: var(--demo-darkBlue)
}
.text-demo-mediumBlue {
    color: var(--demo-mediumBlue)
}
.text-demo-lightBlue {
    color: var(--demo-lightBlue)
}
.text-demo-darkGray {
    color: var(--demo-darkGray)
}
.text-demo-mediumGray {
    color: var(--demo-mediumGray)
}
.text-demo-lightGray {
    color: var(--demo-lightGray)
}
.underline {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline
}
.no-underline {
    -webkit-text-decoration-line: none;
            text-decoration-line: none
}
.opacity-40 {
    opacity: 0.4
}
.opacity-30 {
    opacity: 0.3
}
.opacity-100 {
    opacity: 1
}
.opacity-90 {
    opacity: 0.9
}
.opacity-0 {
    opacity: 0
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-lg {
    --tw-shadow: 0px 8px 32px rgba(0, 0, 0, 0.06);
    --tw-shadow-colored: 0px 8px 32px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.shadow-card {
    --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
    --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px
}
.outline {
    outline-style: solid
}
.outline-8 {
    outline-width: 8px
}
.outline-1 {
    outline-width: 1px
}
.outline-offset-\[3px\] {
    outline-offset: 3px
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}
.ring-4 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}
.ring-blue-responsible-main {
    --tw-ring-color: var(--blue-responsible-main)
}
.ring-blue-responsible-lighten-2 {
    --tw-ring-color: var(--blue-responsible-lighten-2)
}
.ring-cyan-near-lighten-2 {
    --tw-ring-color: var(--cyan-near-lighten-2)
}
.ring-green-guarantee-lighten-2 {
    --tw-ring-color: var(--green-guarantee-lighten-2)
}
.ring-green-quality-lighten-2 {
    --tw-ring-color: var(--green-quality-lighten-2)
}
.ring-orange-lighten-2 {
    --tw-ring-color: var(--orange-lighten-2)
}
.ring-yellow-knowledge-lighten-2 {
    --tw-ring-color: var(--yellow-knowledge-lighten-2)
}
.ring-purple-new-lighten-2 {
    --tw-ring-color: var(--purple-new-lighten-2)
}
.ring-gray-professional-lighten-2 {
    --tw-ring-color: var(--gray-professional-lighten-2)
}
.ring-gray-cosmopolitan-lighten-2 {
    --tw-ring-color: var(--gray-cosmopolitan-lighten-2)
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.drop-shadow {
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.grayscale {
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.sepia {
    --tw-sepia: sepia(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.backdrop-filter {
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
            backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)
}
.transition-colors {
    transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.transition {
    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.duration-300 {
    transition-duration: 300ms
}
.duration-200 {
    transition-duration: 200ms
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.content-\[\"\"\] {
    --tw-content: "";
    content: var(--tw-content)
}
.focus {
    outline-offset: 2px;
    outline-width: 3px;
    outline-style: solid;
    outline-color: #4299e1
}
.hover\:bg-blue-responsible-darken-1:hover {
    background-color: var(--blue-responsible-darken-1)
}
.hover\:text-neutral-white:hover {
    color: var(--neutral-white)
}
.hover\:underline:hover {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline
}
.hover\:no-underline:hover {
    -webkit-text-decoration-line: none;
            text-decoration-line: none
}
.focus\:underline:focus {
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline
}
.active\:focus:active {
    outline-offset: 2px;
    outline-width: 3px;
    outline-style: solid;
    outline-color: #4299e1
}
@media (min-width: 480px) {
    .xs\:absolute {
        position: absolute
    }
    .xs\:right-6 {
        right: 1.5rem
    }
    .xs\:col-span-1 {
        grid-column: span 1 / span 1
    }
    .xs\:col-start-2 {
        grid-column-start: 2
    }
    .xs\:h-\[40px\] {
        height: 40px
    }
    .xs\:h-\[326px\] {
        height: 326px
    }
    .xs\:w-auto {
        width: auto
    }
    .xs\:w-min {
        width: -moz-min-content;
        width: min-content
    }
    .xs\:w-full {
        width: 100%
    }
    .xs\:w-\[49\%\] {
        width: 49%
    }
    .xs\:min-w-\[200px\] {
        min-width: 200px
    }
    .xs\:max-w-\[80\%\] {
        max-width: 80%
    }
    .xs\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
    .xs\:flex-row {
        flex-direction: row
    }
    .xs\:items-start {
        align-items: flex-start
    }
    .xs\:pr-0 {
        padding-right: 0px
    }
    .xs\:pb-2 {
        padding-bottom: 0.5rem
    }
}
@media (min-width: 640px) {
    .sm\:mt-4 {
        margin-top: 1rem
    }
    .sm\:block {
        display: block
    }
    .sm\:flex {
        display: flex
    }
    .sm\:h-\[360px\] {
        height: 360px
    }
    .sm\:w-\[65\%\] {
        width: 65%
    }
    .sm\:w-\[80\%\] {
        width: 80%
    }
    .sm\:w-\[32\%\] {
        width: 32%
    }
    .sm\:max-w-screen-sm {
        max-width: 640px
    }
    .sm\:max-w-\[60\%\] {
        max-width: 60%
    }
    .sm\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }
    .sm\:flex-row {
        flex-direction: row
    }
    .sm\:items-baseline {
        align-items: baseline
    }
    .sm\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .sm\:px-32 {
        padding-left: 8rem;
        padding-right: 8rem
    }
    .sm\:pb-16 {
        padding-bottom: 4rem
    }
    .sm\:text-left {
        text-align: left
    }
    .sm\:\!text-3xl {
        font-size: var(--fs-3xl) !important;
        line-height: var(--lh-3xl) !important
    }
    .sm\:text-2xl {
        font-size: var(--fs-2xl);
        line-height: var(--lh-2xl)
    }
    .sm\:text-sm {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm)
    }
    .sm\:font-semibold {
        font-weight: var(--fw-semibold)
    }
    .sm\:hover\:active\:disabled\:opacity-75:disabled:active:hover {
        opacity: 0.75
    }
}
@media (min-width: 768px) {
    .md\:absolute {
        position: absolute
    }
    .md\:bottom-0 {
        bottom: 0px
    }
    .md\:right-0 {
        right: 0px
    }
    .md\:top-\[40\%\] {
        top: 40%
    }
    .md\:top-2\/4 {
        top: 50%
    }
    .md\:col-start-3 {
        grid-column-start: 3
    }
    .md\:col-start-2 {
        grid-column-start: 2
    }
    .md\:col-start-5 {
        grid-column-start: 5
    }
    .md\:col-end-11 {
        grid-column-end: 11
    }
    .md\:col-end-8 {
        grid-column-end: 8
    }
    .md\:row-start-1 {
        grid-row-start: 1
    }
    .md\:my-20 {
        margin-top: 5rem;
        margin-bottom: 5rem
    }
    .md\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .md\:my-0 {
        margin-top: 0px;
        margin-bottom: 0px
    }
    .md\:mb-\[1\.5rem\] {
        margin-bottom: 1.5rem
    }
    .md\:mb-3 {
        margin-bottom: 0.75rem
    }
    .md\:mr-4 {
        margin-right: 1rem
    }
    .md\:mb-5 {
        margin-bottom: 1.25rem
    }
    .md\:mr-6 {
        margin-right: 1.5rem
    }
    .md\:mt-12 {
        margin-top: 3rem
    }
    .md\:mb-12 {
        margin-bottom: 3rem
    }
    .md\:ml-0 {
        margin-left: 0px
    }
    .md\:mt-7 {
        margin-top: 1.75rem
    }
    .md\:mb-4 {
        margin-bottom: 1rem
    }
    .md\:mt-6 {
        margin-top: 1.5rem
    }
    .md\:mb-6 {
        margin-bottom: 1.5rem
    }
    .md\:mt-auto {
        margin-top: auto
    }
    .md\:mt-\[30px\] {
        margin-top: 30px
    }
    .md\:mt-10 {
        margin-top: 2.5rem
    }
    .md\:block {
        display: block
    }
    .md\:flex {
        display: flex
    }
    .md\:grid {
        display: grid
    }
    .md\:inline-grid {
        display: inline-grid
    }
    .md\:aspect-\[2\] {
        aspect-ratio: 2
    }
    .md\:h-auto {
        height: auto
    }
    .md\:h-full {
        height: 100%
    }
    .md\:h-\[4\.2em\] {
        height: 4.2em
    }
    .md\:h-\[100\%\] {
        height: 100%
    }
    .md\:h-\[140px\] {
        height: 140px
    }
    .md\:h-\[250px\] {
        height: 250px
    }
    .md\:max-h-\[250px\] {
        max-height: 250px
    }
    .md\:max-h-\[400px\] {
        max-height: 400px
    }
    .md\:min-h-\[244px\] {
        min-height: 244px
    }
    .md\:min-h-\[400px\] {
        min-height: 400px
    }
    .md\:min-h-\[500px\] {
        min-height: 500px
    }
    .md\:min-h-\[390px\] {
        min-height: 390px
    }
    .md\:min-h-\[556px\] {
        min-height: 556px
    }
    .md\:w-full-screen-w {
        width: 100vw
    }
    .md\:w-\[60px\] {
        width: 60px
    }
    .md\:w-\[510px\] {
        width: 510px
    }
    .md\:w-\[95\%\] {
        width: 95%
    }
    .md\:w-full {
        width: 100%
    }
    .md\:w-half-screen-w {
        width: 50vw
    }
    .md\:w-fit {
        width: -moz-fit-content;
        width: fit-content
    }
    .md\:w-max {
        width: -moz-max-content;
        width: max-content
    }
    .md\:w-\[140px\] {
        width: 140px
    }
    .md\:w-\[30\%\] {
        width: 30%
    }
    .md\:max-w-screen-md {
        max-width: 768px
    }
    .md\:max-w-\[50\%\] {
        max-width: 50%
    }
    .md\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr))
    }
    .md\:grid-cols-\[1fr_1fr\] {
        grid-template-columns: 1fr 1fr
    }
    .md\:grid-cols-12 {
        grid-template-columns: repeat(12, minmax(0, 1fr))
    }
    .md\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr))
    }
    .md\:grid-cols-\[5fr_7fr\] {
        grid-template-columns: 5fr 7fr
    }
    .md\:grid-rows-\[auto_auto\] {
        grid-template-rows: auto auto
    }
    .md\:grid-rows-1 {
        grid-template-rows: repeat(1, minmax(0, 1fr))
    }
    .md\:flex-row {
        flex-direction: row
    }
    .md\:flex-col {
        flex-direction: column
    }
    .md\:flex-nowrap {
        flex-wrap: nowrap
    }
    .md\:items-start {
        align-items: flex-start
    }
    .md\:items-center {
        align-items: center
    }
    .md\:items-stretch {
        align-items: stretch
    }
    .md\:justify-start {
        justify-content: flex-start
    }
    .md\:justify-between {
        justify-content: space-between
    }
    .md\:gap-10 {
        gap: 2.5rem
    }
    .md\:gap-6 {
        gap: 1.5rem
    }
    .md\:gap-7 {
        gap: 1.75rem
    }
    .md\:gap-8 {
        gap: 2rem
    }
    .md\:gap-4 {
        gap: 1rem
    }
    .md\:self-start {
        align-self: flex-start
    }
    .md\:border-r {
        border-right-width: 1px
    }
    .md\:border-b {
        border-bottom-width: 1px
    }
    .md\:p-8 {
        padding: 2rem
    }
    .md\:p-6 {
        padding: 1.5rem
    }
    .md\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .md\:px-40 {
        padding-left: 10rem;
        padding-right: 10rem
    }
    .md\:py-8 {
        padding-top: 2rem;
        padding-bottom: 2rem
    }
    .md\:py-10 {
        padding-top: 2.5rem;
        padding-bottom: 2.5rem
    }
    .md\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .md\:py-14 {
        padding-top: 3.5rem;
        padding-bottom: 3.5rem
    }
    .md\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
    .md\:py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem
    }
    .md\:px-0 {
        padding-left: 0px;
        padding-right: 0px
    }
    .md\:px-12 {
        padding-left: 3rem;
        padding-right: 3rem
    }
    .md\:py-5 {
        padding-top: 1.25rem;
        padding-bottom: 1.25rem
    }
    .md\:pb-20 {
        padding-bottom: 5rem
    }
    .md\:pl-2 {
        padding-left: 0.5rem
    }
    .md\:pb-5 {
        padding-bottom: 1.25rem
    }
    .md\:pb-0 {
        padding-bottom: 0px
    }
    .md\:pr-\[100px\] {
        padding-right: 100px
    }
    .md\:pt-4 {
        padding-top: 1rem
    }
    .md\:pl-14 {
        padding-left: 3.5rem
    }
    .md\:pb-12 {
        padding-bottom: 3rem
    }
    .md\:pt-2 {
        padding-top: 0.5rem
    }
    .md\:pt-24 {
        padding-top: 6rem
    }
    .md\:pb-24 {
        padding-bottom: 6rem
    }
    .md\:text-left {
        text-align: left
    }
    .md\:text-right {
        text-align: right
    }
    .md\:text-h1-medium {
        font-size: var(--fs-h1-medium);
        line-height: var(--lh-h1-medium)
    }
    .md\:text-h2-medium {
        font-size: var(--fs-h2-medium);
        line-height: var(--lh-h2-medium)
    }
    .md\:text-h3-medium {
        font-size: var(--fs-h3-medium);
        line-height: var(--lh-h3-medium)
    }
    .md\:text-h4-medium {
        font-size: var(--fs-h4-medium);
        line-height: var(--lh-h4-medium)
    }
    .md\:text-h5-medium {
        font-size: var(--fs-h5-medium);
        line-height: var(--lh-h5-medium)
    }
    .md\:text-h6-medium {
        font-size: var(--fs-h6-medium);
        line-height: var(--lh-h6-medium)
    }
    .md\:text-4xl {
        font-size: var(--fs-4xl);
        line-height: var(--lh-4xl)
    }
    .md\:text-xl {
        font-size: var(--fs-xl);
        line-height: var(--lh-xl)
    }
    .md\:text-5xl {
        font-size: var(--fs-5xl);
        line-height: var(--lh-5xl)
    }
    .md\:text-xs {
        font-size: var(--fs-xs);
        line-height: var(--lh-xs)
    }
    .md\:text-3xl {
        font-size: var(--fs-3xl);
        line-height: var(--lh-3xl)
    }
    .md\:text-2xl {
        font-size: var(--fs-2xl);
        line-height: var(--lh-2xl)
    }
    .md\:font-semibold {
        font-weight: var(--fw-semibold)
    }
}
@media (min-width: 1024px) {
    .lg\:absolute {
        position: absolute
    }
    .lg\:bottom-24 {
        bottom: 6rem
    }
    .lg\:col-end-7 {
        grid-column-end: 7
    }
    .lg\:m-0 {
        margin: 0px
    }
    .lg\:m-auto {
        margin: auto
    }
    .lg\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .lg\:my-20 {
        margin-top: 5rem;
        margin-bottom: 5rem
    }
    .lg\:mt-0 {
        margin-top: 0px
    }
    .lg\:mb-0 {
        margin-bottom: 0px
    }
    .lg\:mt-4 {
        margin-top: 1rem
    }
    .lg\:mr-8 {
        margin-right: 2rem
    }
    .lg\:flex {
        display: flex
    }
    .lg\:hidden {
        display: none
    }
    .lg\:h-4 {
        height: 1rem
    }
    .lg\:h-2 {
        height: 0.5rem
    }
    .lg\:h-\[440px\] {
        height: 440px
    }
    .lg\:max-h-full {
        max-height: 100%
    }
    .lg\:min-h-\[600px\] {
        min-height: 600px
    }
    .lg\:w-\[50\%\] {
        width: 50%
    }
    .lg\:w-\[95\.8\%\] {
        width: 95.8%
    }
    .lg\:w-36 {
        width: 9rem
    }
    .lg\:w-\[40\%\] {
        width: 40%
    }
    .lg\:w-auto {
        width: auto
    }
    .lg\:w-\[19\%\] {
        width: 19%
    }
    .lg\:w-1\/2 {
        width: 50%
    }
    .lg\:min-w-min {
        min-width: -moz-min-content;
        min-width: min-content
    }
    .lg\:max-w-screen-lg {
        max-width: 1024px
    }
    .lg\:max-w-\[44\%\] {
        max-width: 44%
    }
    .lg\:flex-auto {
        flex: 1 1 auto
    }
    .lg\:grid-cols-5 {
        grid-template-columns: repeat(5, minmax(0, 1fr))
    }
    .lg\:grid-cols-\[5fr_7fr\] {
        grid-template-columns: 5fr 7fr
    }
    .lg\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr))
    }
    .lg\:flex-row {
        flex-direction: row
    }
    .lg\:flex-wrap {
        flex-wrap: wrap
    }
    .lg\:place-content-center {
        place-content: center
    }
    .lg\:items-center {
        align-items: center
    }
    .lg\:justify-start {
        justify-content: flex-start
    }
    .lg\:justify-center {
        justify-content: center
    }
    .lg\:justify-between {
        justify-content: space-between
    }
    .lg\:px-52 {
        padding-left: 13rem;
        padding-right: 13rem
    }
    .lg\:px-20 {
        padding-left: 5rem;
        padding-right: 5rem
    }
    .lg\:py-24 {
        padding-top: 6rem;
        padding-bottom: 6rem
    }
    .lg\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .lg\:px-24 {
        padding-left: 6rem;
        padding-right: 6rem
    }
    .lg\:px-7 {
        padding-left: 1.75rem;
        padding-right: 1.75rem
    }
    .lg\:py-0 {
        padding-top: 0px;
        padding-bottom: 0px
    }
    .lg\:pl-10 {
        padding-left: 2.5rem
    }
    .lg\:pb-28 {
        padding-bottom: 7rem
    }
    .lg\:pl-6 {
        padding-left: 1.5rem
    }
    .lg\:pl-8 {
        padding-left: 2rem
    }
    .lg\:text-h1 {
        font-size: var(--fs-h1);
        line-height: var(--lh-h1)
    }
    .lg\:text-h2 {
        font-size: var(--fs-h2);
        line-height: var(--lh-h2)
    }
    .lg\:text-h3 {
        font-size: var(--fs-h3);
        line-height: var(--lh-h3)
    }
    .lg\:text-h4 {
        font-size: var(--fs-h4);
        line-height: var(--lh-h4)
    }
    .lg\:text-h5 {
        font-size: var(--fs-h5);
        line-height: var(--lh-h5)
    }
    .lg\:text-h6 {
        font-size: var(--fs-h6);
        line-height: var(--lh-h6)
    }
    .lg\:text-5xl {
        font-size: var(--fs-5xl);
        line-height: var(--lh-5xl)
    }
    .lg\:text-3xl {
        font-size: var(--fs-3xl);
        line-height: var(--lh-3xl)
    }
    .lg\:text-2xl {
        font-size: var(--fs-2xl);
        line-height: var(--lh-2xl)
    }
    .lg\:font-semibold {
        font-weight: var(--fw-semibold)
    }
    .lg\:font-bold {
        font-weight: var(--fw-bold)
    }
}
@media (min-width: 1280px) {
    .xl\:order-1 {
        order: 1
    }
    .xl\:m-6 {
        margin: 1.5rem
    }
    .xl\:my-2 {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem
    }
    .xl\:mb-4 {
        margin-bottom: 1rem
    }
    .xl\:mb-2 {
        margin-bottom: 0.5rem
    }
    .xl\:mb-6 {
        margin-bottom: 1.5rem
    }
    .xl\:mt-0 {
        margin-top: 0px
    }
    .xl\:mb-3 {
        margin-bottom: 0.75rem
    }
    .xl\:mr-4 {
        margin-right: 1rem
    }
    .xl\:mt-4 {
        margin-top: 1rem
    }
    .xl\:mt-6 {
        margin-top: 1.5rem
    }
    .xl\:mt-14 {
        margin-top: 3.5rem
    }
    .xl\:mt-2 {
        margin-top: 0.5rem
    }
    .xl\:ml-3 {
        margin-left: 0.75rem
    }
    .xl\:mb-0 {
        margin-bottom: 0px
    }
    .xl\:ml-1 {
        margin-left: 0.25rem
    }
    .xl\:mt-5 {
        margin-top: 1.25rem
    }
    .xl\:h-\[50px\] {
        height: 50px
    }
    .xl\:h-\[250px\] {
        height: 250px
    }
    .xl\:min-h-\[450px\] {
        min-height: 450px
    }
    .xl\:min-h-\[400px\] {
        min-height: 400px
    }
    .xl\:min-h-\[310px\] {
        min-height: 310px
    }
    .xl\:min-h-\[263px\] {
        min-height: 263px
    }
    .xl\:min-h-\[652px\] {
        min-height: 652px
    }
    .xl\:min-h-\[332px\] {
        min-height: 332px
    }
    .xl\:max-w-\[31\%\] {
        max-width: 31%
    }
    .xl\:flex-row {
        flex-direction: row
    }
    .xl\:flex-nowrap {
        flex-wrap: nowrap
    }
    .xl\:p-4 {
        padding: 1rem
    }
    .xl\:p-6 {
        padding: 1.5rem
    }
    .xl\:p-2 {
        padding: 0.5rem
    }
    .xl\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
    .xl\:py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem
    }
    .xl\:px-32 {
        padding-left: 8rem;
        padding-right: 8rem
    }
    .xl\:py-1 {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem
    }
    .xl\:px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem
    }
    .xl\:px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem
    }
    .xl\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .xl\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem
    }
    .xl\:py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem
    }
    .xl\:py-10 {
        padding-top: 2.5rem;
        padding-bottom: 2.5rem
    }
    .xl\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem
    }
    .xl\:pl-6 {
        padding-left: 1.5rem
    }
    .xl\:pb-0 {
        padding-bottom: 0px
    }
    .xl\:pb-4 {
        padding-bottom: 1rem
    }
    .xl\:pb-24 {
        padding-bottom: 6rem
    }
    .xl\:pb-36 {
        padding-bottom: 9rem
    }
    .xl\:pl-2 {
        padding-left: 0.5rem
    }
    .xl\:pr-4 {
        padding-right: 1rem
    }
    .xl\:pt-2 {
        padding-top: 0.5rem
    }
    .xl\:pb-10 {
        padding-bottom: 2.5rem
    }
    .xl\:pl-4 {
        padding-left: 1rem
    }
    .xl\:pr-32 {
        padding-right: 8rem
    }
    .xl\:text-sm {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm)
    }
    .xl\:text-h1-medium {
        font-size: var(--fs-h1-medium);
        line-height: var(--lh-h1-medium)
    }
    .xl\:text-h2-medium {
        font-size: var(--fs-h2-medium);
        line-height: var(--lh-h2-medium)
    }
    .xl\:text-h3-medium {
        font-size: var(--fs-h3-medium);
        line-height: var(--lh-h3-medium)
    }
    .xl\:text-h4-medium {
        font-size: var(--fs-h4-medium);
        line-height: var(--lh-h4-medium)
    }
    .xl\:text-h5-medium {
        font-size: var(--fs-h5-medium);
        line-height: var(--lh-h5-medium)
    }
    .xl\:text-h6-medium {
        font-size: var(--fs-h6-medium);
        line-height: var(--lh-h6-medium)
    }
    .xl\:text-xxs {
        font-size: var(--fs-xxs);
        line-height: var(--lh-xxs)
    }
    .xl\:text-xs {
        font-size: var(--fs-xs);
        line-height: var(--lh-xs)
    }
    .xl\:text-base {
        font-size: var(--fs-base);
        line-height: var(--lh-base)
    }
    .xl\:text-lg {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg)
    }
    .xl\:text-xl {
        font-size: var(--fs-xl);
        line-height: var(--lh-xl)
    }
    .xl\:text-2xl {
        font-size: var(--fs-2xl);
        line-height: var(--lh-2xl)
    }
    .xl\:text-3xl {
        font-size: var(--fs-3xl);
        line-height: var(--lh-3xl)
    }
    .xl\:text-4xl {
        font-size: var(--fs-4xl);
        line-height: var(--lh-4xl)
    }
    .xl\:text-5xl {
        font-size: var(--fs-5xl);
        line-height: var(--lh-5xl)
    }
    .xl\:text-6xl {
        font-size: var(--fs-6xl);
        line-height: var(--lh-6xl)
    }
    .xl\:text-7xl {
        font-size: var(--fs-7xl);
        line-height: var(--lh-7xl)
    }
    .xl\:text-8xl {
        font-size: var(--fs-8xl);
        line-height: var(--lh-8xl)
    }
    .xl\:text-h2-small {
        font-size: var(--fs-h2-small);
        line-height: var(--lh-h2-small)
    }
    .xl\:text-9xl {
        font-size: var(--fs-9xl);
        line-height: var(--lh-9lx)
    }
}
@media (min-width: 1440px) {
    .xxl\:m-8 {
        margin: 2rem
    }
    .xxl\:mt-4 {
        margin-top: 1rem
    }
    .xxl\:ml-5 {
        margin-left: 1.25rem
    }
    .xxl\:mb-2 {
        margin-bottom: 0.5rem
    }
    .xxl\:max-h-\[350px\] {
        max-height: 350px
    }
    .xxl\:min-h-\[164px\] {
        min-height: 164px
    }
    .xxl\:min-h-\[350px\] {
        min-height: 350px
    }
    .xxl\:w-\[40\%\] {
        width: 40%
    }
    .xxl\:max-w-screen-xxl {
        max-width: 1440px
    }
    .xxl\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr))
    }
    .xxl\:grid-cols-9 {
        grid-template-columns: repeat(9, minmax(0, 1fr))
    }
    .xxl\:p-6 {
        padding: 1.5rem
    }
    .xxl\:p-4 {
        padding: 1rem
    }
    .xxl\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem
    }
    .xxl\:py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem
    }
    .xxl\:px-5 {
        padding-left: 1.25rem;
        padding-right: 1.25rem
    }
    .xxl\:px-16 {
        padding-left: 4rem;
        padding-right: 4rem
    }
    .xxl\:py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem
    }
    .xxl\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .xxl\:py-8 {
        padding-top: 2rem;
        padding-bottom: 2rem
    }
    .xxl\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem
    }
    .xxl\:pt-4 {
        padding-top: 1rem
    }
    .xxl\:pl-6 {
        padding-left: 1.5rem
    }
    .xxl\:pl-0 {
        padding-left: 0px
    }
    .xxl\:text-base {
        font-size: var(--fs-base);
        line-height: var(--lh-base)
    }
    .xxl\:text-xs {
        font-size: var(--fs-xs);
        line-height: var(--lh-xs)
    }
    .xxl\:text-sm {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm)
    }
    .xxl\:text-lg {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg)
    }
    .xxl\:text-xl {
        font-size: var(--fs-xl);
        line-height: var(--lh-xl)
    }
    .xxl\:text-2xl {
        font-size: var(--fs-2xl);
        line-height: var(--lh-2xl)
    }
    .xxl\:text-3xl {
        font-size: var(--fs-3xl);
        line-height: var(--lh-3xl)
    }
    .xxl\:text-4xl {
        font-size: var(--fs-4xl);
        line-height: var(--lh-4xl)
    }
    .xxl\:text-5xl {
        font-size: var(--fs-5xl);
        line-height: var(--lh-5xl)
    }
    .xxl\:text-6xl {
        font-size: var(--fs-6xl);
        line-height: var(--lh-6xl)
    }
    .xxl\:text-7xl {
        font-size: var(--fs-7xl);
        line-height: var(--lh-7xl)
    }
    .xxl\:text-8xl {
        font-size: var(--fs-8xl);
        line-height: var(--lh-8xl)
    }
    .xxl\:text-9xl {
        font-size: var(--fs-9xl);
        line-height: var(--lh-9lx)
    }
}
@media (min-width: 2180px) {
    .xxxl\:max-h-\[640px\] {
        max-height: 640px
    }
    .xxxl\:text-8xl {
        font-size: var(--fs-8xl);
        line-height: var(--lh-8xl)
    }
}
`;